import React, { Component } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody
} from "@chakra-ui/react";
import { FaInfoCircle } from "react-icons/fa";
import "./CustomPopover.scss";
import { IconButton } from "@chakra-ui/react";

interface ControlledUsageState {
  isOpen: boolean;
}
export default class CustomPopover extends Component<
  any,
  ControlledUsageState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.onToggle = this.onToggle.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  onToggle() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  onClose() {
    this.setState({ isOpen: false });
  }

  render() {
    const { isOpen } = this.state;
    const { mainContent, bodyContent } = this.props;
    return (
      <>
        <Popover
          returnFocusOnClose={false}
          isOpen={isOpen}
          onClose={() => this.onClose()}
          placement="top"
          closeOnBlur={false}
        >
          <PopoverTrigger>
            <div className="d-flex align-items-center mx-2">
              <IconButton
                className="icon-button-color"
                icon={<FaInfoCircle></FaInfoCircle>}
                onClick={() => this.onToggle()}
                aria-label="Trigger"
              ></IconButton>
              <div className="w-100">{mainContent}</div>
            </div>
          </PopoverTrigger>
          <PopoverContent color="white" bg="blue.800" borderColor="blue.800">
            <PopoverHeader fontWeight="semibold">Information</PopoverHeader>
            <PopoverArrow bg="blue.800" />
            <PopoverCloseButton />
            <PopoverBody>
              <div>{bodyContent}</div>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </>
    );
  }
}
